import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import useLenisScroll from "@/hooks/useLenisScroll";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import PageTransition from "@/components/layout/PageTransition";
import Home from "@/pages/Home";

const HowItWorks = lazy(() => import("@/pages/HowItWorks"));
const ForInsurance = lazy(() => import("@/pages/ForInsurance"));
const ForBanking = lazy(() => import("@/pages/ForBanking"));
const ForCoops = lazy(() => import("@/pages/ForCoops"));
const Markets = lazy(() => import("@/pages/Markets"));
const About = lazy(() => import("@/pages/About"));
const Contact = lazy(() => import("@/pages/Contact"));

function RouteFallback() {
  return <div className="min-h-[100svh] bg-[#0a1930]" aria-hidden="true" />;
}

function Shell() {
  useLenisScroll();

  return (
    <>
      <Header />
      <main data-testid="site-main">
        <PageTransition>
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/for-insurance" element={<ForInsurance />} />
              <Route path="/for-banking" element={<ForBanking />} />
              <Route path="/for-coops-and-associations" element={<ForCoops />} />
              <Route path="/markets" element={<Markets />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Suspense>
        </PageTransition>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

export default App;
